import { createEntityCollectionStore } from '@core/ngrx-legacy';

import type { JobTemplatesJobBoardEntity } from './job-templates-job-board.types';

const { actions, namespace, selectors, reducer } =
  createEntityCollectionStore<JobTemplatesJobBoardEntity>()('JobTemplatesJobBoards', {
    idSelector: (jobBoard: JobTemplatesJobBoardEntity) => jobBoard.storeId,
  });

export {
  actions as JobTemplatesJobBoardActions,
  namespace as JobTemplatesJobBoardNamespace,
  reducer as JobTemplatesJobBoardReducer,
  selectors as JobTemplatesJobBoardSelectors,
};
